package pl.mothdigital.neuronowi.pages.therapies.wsparcePsychologiczne

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyPsychologicalPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Wsparcie psychologiczne",
            icon = { FaHeart() },
            description = "Pomoc w rozwijaniu umiejętności społecznych, radzeniu sobie z emocjami oraz budowaniu poczucia własnej wartości.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest wsparcie psychologiczne?",
                    content = """
                        Wsparcie psychologiczne to szeroki zakres interwencji terapeutycznych mających na celu
                        poprawę dobrostanu emocjonalnego, rozwój umiejętności społecznych oraz wzmocnienie zasobów
                        osobistych dzieci i młodzieży. W naszym centrum oferujemy kompleksową pomoc psychologiczną
                        dostosowaną do indywidualnych potrzeb każdego dziecka.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest wsparcie psychologiczne?",
                    content = """
                        Wsparcie psychologiczne jest szczególnie pomocne dla dzieci i młodzieży z:

                        • Trudnościami emocjonalnymi (lęki, depresja, stresy)
                        • Problemami behawioralnymi i agresją
                        • Trudnościami w nawiązywaniu relacji społecznych
                        • Zaburzeniami ze spektrum autyzmu
                        • ADHD i trudnościami z koncentracją
                        • Problemami szkolnymi i trudnościami w nauce
                        • Skutkami traumy i trudnych doświadczeń
                        • Niskim poczuciem własnej wartości
                        • Trudnościami adaptacyjnymi
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi wsparcie psychologiczne?",
                    content = """
                        Prawidłowo prowadzone wsparcie psychologiczne może przynieść wiele korzyści:

                        • Poprawę regulacji emocjonalnej
                        • Rozwój umiejętności społecznych
                        • Wzrost poczucia własnej wartości
                        • Lepsze radzenie sobie ze stresem
                        • Poprawę komunikacji z otoczeniem
                        • Zwiększenie motywacji do nauki
                        • Lepsze funkcjonowanie w rodzinie i szkole
                        • Rozwój strategii rozwiązywania problemów
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces wsparcia psychologicznego w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową diagnozę psychologiczną - ocenę funkcjonowania emocjonalnego,
                           społecznego i poznawczego dziecka.

                        2. Opracowanie indywidualnego planu terapeutycznego dostosowanego do potrzeb
                           i wieku dziecka.

                        3. Regularne sesje terapeutyczne z wykorzystaniem technik odpowiednich dla wieku
                           (terapia przez zabawę, arteterapia, terapia poznawczo-behawioralna).

                        4. Współpracę z rodzicami - edukację, wsparcie i instruktaż dotyczący pracy z dzieckiem.

                        5. Koordynację z innymi specjalistami i nauczycielami w celu zapewnienia
                           kompleksowego wsparcia.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W pracy psychologicznej stosujemy różnorodne techniki i podejścia:

                        • Terapię poznawczo-behawioralną (CBT)
                        • Terapię przez zabawę
                        • Arteterapię i muzykoterapię
                        • Trening umiejętności społecznych (TUS)
                        • Techniki relaksacyjne i mindfulness
                        • Terapię systemową rodzinną
                        • Programy rozwijające inteligencję emocjonalną
                        • Biofeedback i neurofeedback
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Wsparcie psychologiczne w naszym centrum prowadzą doświadczeni psycholodzy dziecięcy
                        i psychoterapeuci z wieloletnim doświadczeniem w pracy z dziećmi i młodzieżą.
                        Nasi specjaliści posiadają odpowiednie certyfikaty i kwalifikacje, regularnie uczestniczą
                        w szkoleniach i superwizjach, aby zapewnić pacjentom najwyższą jakość opieki psychologicznej.
                    """.trimIndent()
                )
            )
        )
    )
}
